import { TagItem } from '../../tag/Tag';

export type Category = 'facturation' | 'crea' | 'compta';

type CategoryKeywords = {
    [K in Category]: string[];
};

const CATEGORY_KEYWORDS: CategoryKeywords = {
    facturation: ['factu', 'facturation'],
    crea: ['creation', 'crea', 'creer'],
    compta: ['comptabilite', 'comptable'],
};

const CATEGORY_BLOG_KEYWORDS: CategoryKeywords = {
    facturation: ['logiciel de facturation'],
    crea: [
        "création d'entreprise",
        'SASU',
        'entrepreneur',
        'dirigeant',
        'SCI',
        'holding',
        'EI',
        'indépendants',
        'Micro entreprise',
        'eurl',
        'LMNP',
        'Business plan',
        'SARL',
        'Capital social',
        'auto-entrepreneur',
        "Tout savoir sur la création d'entreprise",
        'Acre',
        'Immobilisation',
        'eirl',
        'Prévisionnel',
        'eurl/sarl',
        'SCI lmnp',
    ],
    compta: [
        'comptabilité',
        'RH/Social',
        "charges de l'entreprise",
        'ecommerce',
        'Rémunération',
        'base de la compta',
        'Tout savoir sur le dropshipping',
        'comptable',
        'logiciel de facturation',
        'TNS',
        'VTC',
        'Assurance',
        'CFE',
        'expert-comptable en ligne',
        'IS',
        'freelance',
        'TVS',
        'IR',
        'TVA',
        'prospection vente',
        'Video',
    ],
};

const DEFAULT_CATEGORY = 'compta';

export const determineCategory = (pathname: string, tagList: TagItem[]): Category => {
    // pages tags
    if (pathname.includes('tag')) {
        const tagKeyword = pathname.split('tag/')[1]?.split('/')[0]?.toLowerCase();
        if (tagKeyword) {
            const categoryFromTag = (Object.entries(CATEGORY_BLOG_KEYWORDS) as [Category, string[]][]).find(entry =>
                entry[1].some(keyword => keyword.toLowerCase().includes(tagKeyword)),
            )?.[0];
            return categoryFromTag ?? DEFAULT_CATEGORY;
        }
        return DEFAULT_CATEGORY;
    }

    // pages articles
    if (tagList.length > 0) {
        const categoryFromTags = (Object.entries(CATEGORY_BLOG_KEYWORDS) as [Category, string[]][]).find(entry =>
            entry[1].some(keyword => tagList.some(tag => tag.text.toLowerCase().includes(keyword.toLowerCase()))),
        )?.[0];

        if (categoryFromTags) {
            return categoryFromTags;
        }

        return categoryFromTags ?? DEFAULT_CATEGORY;
    }

    // Autres pages
    const category = (Object.entries(CATEGORY_KEYWORDS) as [Category, string[]][]).find(entry =>
        entry[1].some(keyword => pathname.includes(keyword)),
    )?.[0];

    return category ?? DEFAULT_CATEGORY;
};
